<script setup>
/*
 * Hvad koster hele opsaetningen, og hvor.
 *
 * FRAGTEN ER POINTEN. Koeber man otte dele hos otte butikker, betaler
 * man otte gange fragt, og saa er den billigste enkeltpris pludselig
 * ikke den billigste handel.
 */
import { computed } from 'vue';

const props = defineProps({ data: { type: Object, required: true } });

const butikker = computed(() => props.data.butikker || []);

function kr(v) {
    const n = Number(v);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', maximumFractionDigits: 0 }).format(n);
}
</script>

<template>
    <p v-if="!butikker.length" class="text-secondary small mb-0">
        Ingen butikker har varerne lige nu.
    </p>

    <div v-else>
        <div class="table-responsive">
            <table class="table table-sm align-middle mb-2">
                <thead>
                    <tr>
                        <th>Butik</th>
                        <th class="text-end">Varer</th>
                        <th class="text-end">Varepris</th>
                        <th class="text-end">Fragt</th>
                        <th class="text-end">I alt</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(b, i) in butikker" :key="i" :class="{ 'table-success': i === 0 }">
                        <td>{{ b.butik?.name || b.navn }}</td>
                        <td class="text-end">{{ b.antal_varer ?? b.antal }} / {{ data.antalVarer }}</td>
                        <td class="text-end">{{ kr(b.varepris ?? b.pris) }}</td>
                        <td class="text-end">{{ kr(b.fragt) }}</td>
                        <td class="text-end fw-semibold">{{ kr(b.total ?? b.i_alt) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <p class="small text-secondary mb-0">
            Fragten tælles én gang pr. butik, ikke én gang pr. vare. Kun nye varer regnes med —
            en refurbished skærm til det halve er ikke et billigere setup, det er et andet setup.
        </p>
    </div>
</template>
